var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { useContext, useEffect, useState } from 'react';
import { LoadingContext } from '../../context/loading';
export function useCtaTokenRates() {
    var setServerLoading = useContext(LoadingContext).setServerLoading;
    var _a = useState(0), ctaTokenUsdRate = _a[0], setCtaTokenUsdRate = _a[1];
    var _b = useState(0), ctaTokenUsdRate7d = _b[0], setCtaTokenUsdRate7d = _b[1];
    var _c = useState(''), timestamp = _c[0], setTimestamp = _c[1];
    var _d = useState(0), secondsBeforeRefetch = _d[0], setSecondsBeforeRefetch = _d[1];
    var _e = useState(null), refetchInterval = _e[0], setRefetchInverval = _e[1];
    var _f = useState(null), updateSecondsInterval = _f[0], setUpdateSecondsInterval = _f[1];
    useEffect(function () {
        setServerLoading(ctaTokenUsdRate === 0);
    }, [ctaTokenUsdRate]);
    useEffect(function () {
        function initialize() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, refetchRates()];
                        case 1:
                            _a.sent();
                            setRefetchInverval(setInterval(function () { return refetchRates(); }, 30000));
                            setUpdateSecondsInterval(setInterval(function () {
                                setSecondsBeforeRefetch(function (value) { return Math.max(0, value - 1); });
                            }, 1000));
                            return [2 /*return*/];
                    }
                });
            });
        }
        initialize();
        return function () {
            if (refetchInterval) {
                clearInterval(refetchInterval);
            }
            if (updateSecondsInterval) {
                clearInterval(updateSecondsInterval);
            }
        };
    }, []);
    function refetchRates() {
        return __awaiter(this, void 0, Promise, function () {
            var rates;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, gqlSdk.CtaTokenGetRates()];
                    case 1:
                        rates = _e.sent();
                        setCtaTokenUsdRate(((_a = rates.ctaTokenGetRates) === null || _a === void 0 ? void 0 : _a.usd) || ctaTokenUsdRate);
                        setCtaTokenUsdRate7d(((_b = rates.ctaTokenGetRates) === null || _b === void 0 ? void 0 : _b.usd7d) || ctaTokenUsdRate7d);
                        setTimestamp(((_c = rates.ctaTokenGetRates) === null || _c === void 0 ? void 0 : _c.timestamp) || '0');
                        setSecondsBeforeRefetch(30);
                        return [2 /*return*/, ((_d = rates.ctaTokenGetRates) === null || _d === void 0 ? void 0 : _d.expireAt) || ''];
                }
            });
        });
    }
    return { ctaTokenUsdRate: ctaTokenUsdRate, ctaTokenUsdRate7d: ctaTokenUsdRate7d, timestamp: timestamp, secondsBeforeRefetch: secondsBeforeRefetch };
}
